<template>
  <div>
    <div id="container"></div>
  </div>
</template>

<script>
export default {
  name: 'test',
  props: {
    vid: String,
  },
  data() {
    return {
      autoplay: false,
      videoUrl: '',
    }
  },
  mounted() {
    this.initVideo()
    // this.initWeixinJSBridge()
  },
  methods: {
    // initWeixinJSBridge() {
    //   const that = this
    //   function callback() {
    //     WeixinJSBridge.invoke('getNetworkType', {}, (res) => {
    //       if (res.err_msg && res.err_msg.indexOf('wifi') >= 0) {
    //         that.autoplay = true
    //       }
    //       that.initVideo()
    //     })
    //   }
    //   if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
    //     callback()
    //   } else if (document.addEventListener) {
    //     document.addEventListener('WeixinJSBridgeReady', callback, false)
    //   } else if (document.attachEvent) {
    //     document.attachEvent('WeixinJSBridgeReady', callback)
    //     document.attachEvent('onWeixinJSBridgeReady', callback)
    //   }
    // },
    initVideo() {
      const player = new Txplayer({
        containerId: 'container',
        vid: this.vid,
        width: '100%',
        height: '100%',
        autoplay: true,
      })
    },
  },
}
</script>

<style scoped lang="scss">
#container {
  width: 100%;
  height: 50vw;
}
</style>

